import React from 'react';
import VisitDatePicker from '../../molecules/VisitDatePicker';
import VistReservationTable from '../VistReservationTable';
import ListCount from '../../molecules/ListCount';
import { VisitReservationListInfo } from '../../../redux/reducers/VisitReservationInfoReducer';
import { MasterInfoState } from '../../../redux/reducers/MasterInfoReducer';
import VisitStoreNotSelectedMessage from '../VisitStoreNotSelectedMessage';
import { GASpotEventState } from '../NegotiationCountList';

export interface VisitListProps {
  visitReservationListInfo: VisitReservationListInfo;
  availableStoreCnt: number;
  masterInfo: MasterInfoState;
  targetStore: string;
  targetDate: Date;
  inquiryDate: Date;
  isPastDay: boolean;
  updateTargetDate: (targetDate: Date) => void;
  isShowVisitSelectStoreModal: boolean;
  gaSpotEvent: GASpotEventState;
}

const VisitList: React.FC<VisitListProps> = ({
  visitReservationListInfo,
  availableStoreCnt,
  masterInfo,
  targetStore,
  targetDate,
  inquiryDate,
  isPastDay,
  updateTargetDate,
  isShowVisitSelectStoreModal,
  gaSpotEvent,
}) => {
  /**
   * 来店予約「予約一覧」タブの内容
   */
  const VisitListDisp = () => {
    return targetStore ? (
      <div className='container u-pb0 layout-tab'>
        <div className='clearfix'>
          <div className='u-float-left'>
            {/* 日付選択部分 */}
            <VisitDatePicker className='u-mh16' value={targetDate} inquiryDate={inquiryDate} updateDate={updateTargetDate} />
          </div>
          {/* 件数 */}
          <ListCount isRight className='u-float-right' count={visitReservationListInfo.count} />
        </div>
        {/* リスト */}
        <VistReservationTable
          gaSpotEvent={gaSpotEvent}
          itemList={visitReservationListInfo.list}
          masterInfo={masterInfo}
          isPastDay={isPastDay}
        />
      </div>
    ) : (
      <VisitStoreNotSelectedMessage
        masterInfo={masterInfo}
        availableStoreCnt={availableStoreCnt}
        isShowVisitSelectStoreModal={isShowVisitSelectStoreModal}
      />
    );
  };

  return VisitListDisp();
};

export default VisitList;
